import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const TechnicalDocument = props => (
  <Fragment>
    <tr>
      <td className="icon-cell">
        <span className={`icon ${props.revisions.extension === 'pdf' ? 'icon-rs_33-file-pdf' : 'icon-rs_137-zip'}`} />
      </td>
      <td className="title-cell"><a
        href={props.href}
      >{props.title}</a></td>
      <td className="update-cell">{props.revisions.created}</td>
      <td className="revision-cell">{props.latestRevision}</td>
      <td className="language-cell">{props.language}</td>
    </tr>
  </Fragment>
);

TechnicalDocument.propTypes = {
  title: PropTypes.string,
  created: PropTypes.number,
  language: PropTypes.string,
  latestRevision: PropTypes.number,
  revisions: PropTypes.shape({
    path: PropTypes.string,
    revision: PropTypes.number,
    manufacturerRevision: PropTypes.string,
    extension: PropTypes.string,
    size: PropTypes.number,
    created: PropTypes.string,
  }),
  href: PropTypes.string,
};

TechnicalDocument.defaultProps = {
  title: '',
  created: 0,
  language: '',
  latestRevision: 0,
  revisions: {},
  href: '',
};

export default TechnicalDocument;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/TechnicalDocument/TechnicalDocument.js